// Все иконки интерфейса берутся отсюда. Набор — Untitled UI Icons, как в макете
// UIGPN: контур 2px, скругления, цвет — currentColor (наследуется от текста).
//
// Сменить иконку во всём интерфейсе = поменять одну строку ниже.
// Новая иконка: выбрать на https://www.untitledui.com/free-icons и добавить сюда.
import {
  AlertCircle,
  ArrowRight as UArrowRight,
  Building07,
  Check as UCheck,
  CheckCircle,
  ChevronDown as UChevronDown,
  DotsVertical,
  Download01,
  Edit05,
  Eye as UEye,
  EyeOff as UEyeOff,
  Copy04,
  File06,
  FileCheck02,
  FileSearch02,
  FileShield02,
  FilterLines,
  InfoCircle,
  LogIn04,
  LogOut01,
  Menu01,
  Package,
  Plus as UPlus,
  SearchLg,
  Settings01,
  Settings04,
  Trash01,
  Truck01,
  UploadCloud02,
  User01,
  Users01,
  XClose,
} from '@untitledui/icons';
import { CSSProperties, FC, SVGProps } from 'react';

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

type UntitledIcon = FC<IconProps & { color?: string }>;

// Иконка с размером и цветом по умолчанию; оба можно переопределить пропсами.
const icon = (Icon: UntitledIcon, defaultSize: number, defaultColor?: string) => {
  const Sized = ({ size = defaultSize, style, ...props }: IconProps) => (
    <Icon
      size={size}
      style={defaultColor ? ({ color: defaultColor, ...style } as CSSProperties) : style}
      {...props}
    />
  );
  Sized.displayName = Icon.displayName;
  return Sized;
};

// Действия
export const Close = icon(XClose, 24);
export const Search = icon(SearchLg, 16);
export const Edit = icon(Edit05, 16);
export const Plus = icon(UPlus, 16);
export const More = icon(DotsVertical, 20);
export const Filter = icon(FilterLines, 16);
export const Remove = icon(Trash01, 16);
export const Download = icon(Download01, 16);
export const Upload = icon(UploadCloud02, 40, 'var(--color-text-subtle)');
export const Eye = icon(UEye, 20);
export const EyeOff = icon(UEyeOff, 20);
export const Check = icon(UCheck, 16);
export const Settings = icon(Settings01, 20);
export const SettingsTable = icon(Settings04, 16);
export const Menu = icon(Menu01, 24);
export const Login = icon(LogIn04, 40);
export const Logout = icon(LogOut01, 16);
export const ArrowRight = icon(UArrowRight, 24);
export const ChevronDown = icon(UChevronDown, 16);

// Объекты
export const File = icon(File06, 20);
export const User = icon(User01, 16);
export const Info = icon(InfoCircle, 20, 'var(--color-primary)');
export const Alert = icon(AlertCircle, 20);

// Разделы бокового меню
/** Договор — документ; галочка (FileCheck) уехала на доверенности (KCONT-2338). */
export const Contracts = icon(File06, 20);
export const PowersAttorney = icon(FileCheck02, 20);
/** Пачка документов для группы «Цифровые паспорта». */
export const DigitalPassports = icon(Copy04, 20);
export const Counterparties = icon(Users01, 20);
export const Organization = icon(Building07, 20);
export const Assets = icon(Package, 20);
export const FuelSupply = icon(Truck01, 20);

// Крупные значки для пустых и итоговых состояний
export const EmptyState = icon(FileSearch02, 64, 'var(--color-text-subtle)');
export const Success = icon(CheckCircle, 64, 'var(--color-success)');

export { Logo } from 'dynamic/assets/logo';
